var map = {
	"./christmas/present.vue": [
		"e947",
		"chunk-602eefb2"
	],
	"./christmas/reindeer.vue": [
		"93ef",
		"chunk-352c2a24"
	],
	"./christmas/santa.vue": [
		"4561",
		"chunk-81bf4066"
	],
	"./christmas/snowman.vue": [
		"a9a1",
		"chunk-51588a61"
	],
	"./christmas/star.vue": [
		"79b7",
		"chunk-3d41a332"
	],
	"./christmas/tree.vue": [
		"38fd",
		"chunk-b69c8974"
	],
	"./halloween/cat.vue": [
		"ca14",
		"chunk-61f84e30"
	],
	"./halloween/ghost.vue": [
		"82fa",
		"chunk-15a24f34"
	],
	"./halloween/owl.vue": [
		"eaf1",
		"chunk-33cf1cfc"
	],
	"./halloween/pumpkin.vue": [
		"d997",
		"chunk-572cae14"
	],
	"./halloween/witch_hat.vue": [
		"1ab8",
		"chunk-008ae4a3"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2917";
module.exports = webpackAsyncContext;